"use client";

import { Plus } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Button } from "@/components/ui/button";
export default function Instagramsocialfeed() {
  const look01 = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const look02 = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const look03 = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const look04 = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const look05 = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const gridImages = [{
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1722769/img/lush_lookbook_grid_01.webp",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1722769/img/lush_lookbook_grid_01.webp-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1722769/img/lush_lookbook_grid_01.webp-wvc-sizes",
    alt: "Look 03 — Silk evening gown in urban setting",
    look: "LOOK 03",
    caption: "Silk Evening Gown"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1722769/img/lush_lookbook_grid_02.webp",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1722769/img/lush_lookbook_grid_02.webp-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1722769/img/lush_lookbook_grid_02.webp-wvc-sizes",
    alt: "Look 04 — Tailored blazer on city street",
    look: "LOOK 04",
    caption: "Tailored Blazer"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1722769/img/lush_lookbook_grid_03.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1722769/img/lush_lookbook_grid_03.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1722769/img/lush_lookbook_grid_03.png-wvc-sizes",
    alt: "Look 05 — Cashmere sweater with pleated skirt",
    look: "LOOK 05",
    caption: "Cashmere Knit"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1722769/img/lush_lookbook_grid_04.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1722769/img/lush_lookbook_grid_04.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1722769/img/lush_lookbook_grid_04.png-wvc-sizes",
    alt: "Look 09 — Minimalist accessories",
    look: "LOOK 09",
    caption: "Gold Accents"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1722769/img/lush_lookbook_grid_05.webp",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1722769/img/lush_lookbook_grid_05.webp-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1722769/img/lush_lookbook_grid_05.webp-wvc-sizes",
    alt: "Look 10 — Urban street style",
    look: "LOOK 10",
    caption: "Street Luxe"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1722769/img/lush_lookbook_grid_06.webp",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1722769/img/lush_lookbook_grid_06.webp-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1722769/img/lush_lookbook_grid_06.webp-wvc-sizes",
    alt: "Look 11 — Evening clutch detail",
    look: "LOOK 11",
    caption: "Satin Clutch"
  }];
  const diptychImages = [{
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1722769/img/lush_lookbook_diptych_01.webp",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1722769/img/lush_lookbook_diptych_01.webp-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1722769/img/lush_lookbook_diptych_01.webp-wvc-sizes",
    alt: "Look 07 — Profile portrait in velvet dress",
    look: "LOOK 07",
    caption: "Velvet Midi / Midnight Blue"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1722769/img/lush_lookbook_diptych_02.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1722769/img/lush_lookbook_diptych_02.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1722769/img/lush_lookbook_diptych_02.png-wvc-sizes",
    alt: "Look 08 — Editorial pose in leather jacket",
    look: "LOOK 08",
    caption: "Leather Jacket / Urban Chic"
  }];
  return <section data-section-id="3639" id="instagramsocialfeed" className="bg-background text-foreground py-20 md:py-32 overflow-hidden">
      <div className="max-w-[1600px] mx-auto px-6 md:px-12">
        <div className="max-w-3xl mb-20 md:mb-32">
          <p className="font-default text-xs tracking-[0.25em] uppercase text-muted-foreground mb-6">
            The Lookbook / Season 2024
          </p>
          <h1 className="font-default text-5xl md:text-7xl lg:text-8xl font-semibold leading-[0.95] text-foreground mb-8">
            Modern luxury in
            <span className="italic"> every </span>
            stitch.
          </h1>
          <p className="font-default text-base md:text-lg text-muted-foreground max-w-xl leading-relaxed">
            A curated visual journey through our latest fashion collections, designed for the modern individual who values timeless elegance and premium craftsmanship.
          </p>
        </div>

        <div ref={look01.ref} data-index={0} className={`mb-24 md:mb-40 transition-all duration-[800ms] ease-out ${look01.isVisible ? "opacity-100 [clip-path:inset(0_0_0_0)]" : "opacity-0 [clip-path:inset(100%_0_0_0)]"}`}>
          <div className="relative group cursor-pointer">
            <div className="relative overflow-hidden rounded-lg shadow-lg">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1722769/img/lush_lookbook_look01_landscape.webp" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1722769/img/lush_lookbook_look01_landscape.webp-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1722769/img/lush_lookbook_look01_landscape.webp-wvc-sizes" alt="Look 01 — Editorial landscape of model in designer coat" loading="lazy" decoding="async" className="w-full h-[60vh] md:h-[85vh] object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-[1.02]" />
              <div className="absolute bottom-6 md:bottom-10 left-6 md:left-10">
                <p className={`font-default text-xs tracking-[0.3em] uppercase text-white bg-primary/80 backdrop-blur-sm px-3 py-2 rounded-lg transition-opacity duration-500 delay-200 ${look01.isVisible ? "opacity-100" : "opacity-0"}`}>
                  — LOOK 01
                </p>
              </div>
              <div className="absolute top-6 right-6 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <div className="flex items-center gap-2 bg-white/90 backdrop-blur-md text-foreground font-default text-xs tracking-widest uppercase px-4 py-2 rounded-lg shadow-md">
                  <Plus className="size-3" />
                  View
                </div>
              </div>
            </div>
            <p className="font-default text-[10px] md:text-xs tracking-[0.25em] uppercase text-muted-foreground mt-4 ml-2">
              Signature Trench / Premium Cotton / Tailored Fit
            </p>
          </div>
        </div>

        <div ref={look02.ref} data-index={1} className="mb-24 md:mb-40 grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-12 items-center">
          <div className={`md:col-span-5 transition-all duration-[800ms] ease-out ${look02.isVisible ? "opacity-100 [clip-path:inset(0_0_0_0)]" : "opacity-0 [clip-path:inset(100%_0_0_0)]"}`}>
            <div className="relative group cursor-pointer">
              <div className="overflow-hidden rounded-lg shadow-lg">
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1722769/img/lush_lookbook_look02_portrait.webp" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1722769/img/lush_lookbook_look02_portrait.webp-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1722769/img/lush_lookbook_look02_portrait.webp-wvc-sizes" alt="Look 02 — Portrait of model in evening wear" loading="lazy" decoding="async" className="w-full h-[500px] md:h-[720px] object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-[1.03]" />
                <div className="absolute top-6 right-6 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <div className="flex items-center gap-2 bg-white/90 backdrop-blur-md text-foreground font-default text-xs tracking-widest uppercase px-4 py-2 rounded-lg shadow-md">
                    <Plus className="size-3" />
                    View
                  </div>
                </div>
              </div>
              <p className="font-default text-[10px] md:text-xs tracking-[0.25em] uppercase text-muted-foreground mt-4">
                — Look 02 / Evening Silk
              </p>
            </div>
          </div>

          <div className={`md:col-span-7 md:pl-8 transition-all duration-[800ms] ease-out delay-200 ${look02.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <p className="font-default text-xs tracking-[0.3em] uppercase text-muted-foreground mb-8">
              The philosophy of style
            </p>
            <blockquote className="font-default text-3xl md:text-5xl lg:text-6xl font-semibold leading-[1.1] text-foreground italic mb-10">
              "true luxury is found in the details that go unnoticed, yet define the entire experience of wearing a garment."
            </blockquote>
            <p className="font-default text-xs tracking-[0.2em] uppercase text-muted-foreground mb-10">
              — Lush Fashion, Design Team
            </p>

            <div className="relative inline-block group cursor-pointer">
              <div className="overflow-hidden rounded-lg shadow-md w-48 md:w-64">
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1722769/img/lush_lookbook_detail_fabric.webp" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1722769/img/lush_lookbook_detail_fabric.webp-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1722769/img/lush_lookbook_detail_fabric.webp-wvc-sizes" alt="Close-up detail of premium fabric texture" loading="lazy" decoding="async" className="w-full h-32 md:h-40 object-cover transition-transform duration-700 group-hover:scale-105" />
              </div>
              <p className="font-default text-[10px] tracking-[0.25em] uppercase text-muted-foreground mt-3">
                Detail / Premium Texture
              </p>
            </div>
          </div>
        </div>

        <div ref={look03.ref} data-index={2} className="mb-24 md:mb-40 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-6">
          {gridImages.map((img, i) => <div data-index={i} key={i} className={`transition-all duration-[800ms] ease-out ${look03.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`} style={{
          transitionDelay: look03.isVisible ? `${i * 100}ms` : "0ms"
        }}>
              <div className="relative group cursor-pointer bg-white overflow-hidden rounded-lg shadow-md aspect-square">
                <img src={img.src} data-wvc-srcset={img.srcset} data-wvc-sizes={img.sizes} alt={img.alt} loading="lazy" decoding="async" className="w-full h-full object-cover grayscale transition-all duration-[1200ms] ease-out group-hover:grayscale-0 group-hover:scale-105" />
                <div className="absolute inset-0 bg-black/20 opacity-0 group-hover:opacity-100 transition-opacity duration-500 flex flex-col items-center justify-center p-4 text-center">
                  <p className="font-default text-[10px] tracking-[0.3em] uppercase text-white mb-2">
                    {img.look}
                  </p>
                  <p className="font-default text-[11px] tracking-[0.15em] uppercase text-white font-medium leading-tight">
                    {img.caption}
                  </p>
                  <div className="mt-4 bg-white/90 backdrop-blur-md p-2 rounded-lg shadow-sm">
                    <Plus className="size-3 text-primary" />
                  </div>
                </div>
              </div>
            </div>)}
        </div>

        <div ref={look04.ref} data-index={3} className={`mb-24 md:mb-40 -mx-6 md:-mx-12 transition-all duration-[1000ms] ease-out ${look04.isVisible ? "opacity-100 [clip-path:inset(0_0_0_0)]" : "opacity-0 [clip-path:inset(100%_0_0_0)]"}`}>
          <div className="relative group cursor-pointer">
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1722769/img/lush_lookbook_look06_fullbleed.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1722769/img/lush_lookbook_look06_fullbleed.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1722769/img/lush_lookbook_look06_fullbleed.png-wvc-sizes" alt="Look 06 — Full-bleed editorial of model in urban environment" loading="lazy" decoding="async" className="w-full h-[70vh] md:h-[95vh] object-cover transition-transform duration-[1500ms] ease-out group-hover:scale-[1.02]" />
            <div className="absolute top-6 right-6 md:top-10 md:right-10 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
              <div className="flex items-center gap-2 bg-white/90 backdrop-blur-md text-foreground font-default text-xs tracking-widest uppercase px-4 py-2 rounded-lg shadow-md">
                <Plus className="size-3" />
                View
              </div>
            </div>
          </div>
        </div>

        <div ref={look05.ref} data-index={4} className="mb-20 md:mb-32 grid grid-cols-2 gap-2 md:gap-4">
          {diptychImages.map((img, i) => <div data-index={i} key={i} className={`transition-all duration-[800ms] ease-out ${look05.isVisible ? "opacity-100 [clip-path:inset(0_0_0_0)]" : "opacity-0 [clip-path:inset(100%_0_0_0)]"}`} style={{
          transitionDelay: look05.isVisible ? `${i * 200}ms` : "0ms"
        }}>
              <div className="relative group cursor-pointer">
                <div className="overflow-hidden rounded-lg shadow-md">
                  <img src={img.src} data-wvc-srcset={img.srcset} data-wvc-sizes={img.sizes} alt={img.alt} loading="lazy" decoding="async" className="w-full h-[400px] md:h-[720px] object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-[1.04]" />
                  <div className="absolute top-4 right-4 md:top-6 md:right-6 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                    <div className="flex items-center gap-2 bg-white/90 backdrop-blur-md text-foreground font-default text-[10px] md:text-xs tracking-widest uppercase px-3 py-2 rounded-lg shadow-md">
                      <Plus className="size-3" />
                      View
                    </div>
                  </div>
                </div>
                <div className="mt-4 flex flex-col md:flex-row md:items-baseline md:justify-between gap-1 md:gap-4">
                  <p className="font-default text-[10px] md:text-xs tracking-[0.25em] uppercase text-foreground">
                    — {img.look}
                  </p>
                  <p className="font-default text-[10px] md:text-xs tracking-[0.2em] uppercase text-muted-foreground">
                    {img.caption}
                  </p>
                </div>
              </div>
            </div>)}
        </div>

        <div className="flex flex-col md:flex-row items-start md:items-end justify-between gap-8 pt-12 border-t border-border relative">
          <div>
            <p className="font-default text-xs tracking-[0.3em] uppercase text-muted-foreground mb-4">
              End of Season
            </p>
            <p className="font-default text-2xl md:text-4xl font-semibold text-foreground italic max-w-lg leading-tight">
              Elevate your wardrobe with Lush Fashion.
            </p>
          </div>
          <Button size="lg" className="font-default text-xs tracking-[0.25em] uppercase rounded-lg px-8 h-12 bg-primary text-white hover:bg-primary/90">
            Shop The Collection
          </Button>
          <div className="absolute bottom-0 left-0 w-full h-px bg-accent/30" />
        </div>
      </div>
    </section>;
}